const  projectsPHP = [
    {
       proTitle: "PHP projects", 
       projectProps: [
        {
            title: "PHP and MySQL",
            img: "./img_projects/php/project1.png",
            desc: "Applicazione WEB costruita sui dati ricevuti da MySQL database e jQuery/AJAX lo stile é gestito da CSS.",
            long_desc: `Applicazione di vendita di prodotti agricoli su prenotazione.
            <p>Il software che impagina i dati che ricava da database MySQL tramite CSS.</p>`,
            topics: "PHP, AJAX, CSS/HTML, MySQL, jQuery, Javascript",
            location_url: "./web_app/projects/php/savio_sito/index.php",
            source_code: true
        },
        {
            title: "Pizzeria web site",
            img: "./img_projects/php/project2.png",
            desc: "Applicazione costruita su dati provenienti dal database MySQL e da AJAX, impaginata con stile CSS ed SVG.",
            long_desc: `Applicazione vetrina che mostra i prodotti in vendita di una pizzeria.
            <p>Ottiene i dati per creare il layout dal database MySQL e da file di testo tramite AJAX/LOAD.</p>`,
            topics: "PHP, AJAX, CSS/HTML, MySQL, jQuery, Javascript, SVG",
            location_url: "./web_app/projects/php/pizza/index.html",
            source_code: true
        },
        {
            title: "PHP OOP File Downloader",
            img: "./img_projects/php/project3.png",
            desc: "OOP PHP file download.",
            long_desc: `Mostra come effettuare il download di un file tramite PHP/OOP in quattro maniere diverse.`,
            topics: "PHP, OOP",
            location_url: "https://github.com/pippo-github/php_downloader_4_ways",
            // location_url: "./web_app/projects/php/php_downloader/index.php", mettere il link a github non permette la creazione di file aruba.it
            source_code: true
        },
        {
            title: "PHP WEB Scraper",
            img: "./img_projects/php/project4.png",
            desc: "PHP OOP web Scraper",
            long_desc: `Questo codice permette di estrarre detreminate informazioni da una web page on line attraverso la classe.`,
            topics: "PHP/OOP",
            location_url: "https://github.com/pippo-github/PHP_WEB_SCRAPLER",
            source_code: true
        }
    ]
    }
]

export {projectsPHP}
